import { useTranslation } from "react-i18next";
import DF from "../../../Assets/img/whatsapp.png";
import { CustomModal, ButtonText } from "./styles";
import React from "react";
import { Button } from "@material-ui/core";
import { cancelBtn2, ButtonGreen, ButtonBlue } from "../../../Styles/buttons";
import { createWidget, getWidget } from "../../../Services/campaignFunctions";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";

import AlertNotify from "../../../Common/Components/Alert";
import WebsiteWidgetForm from "../WebsiteWidgetForm";

const WebWidgetModal = ({ campaignName, phone, camapignId, link }) => {
  const [widgetModal, setWidgetModal] = React.useState(false);
  const BtnCancel = cancelBtn2();

  const { t } = useTranslation();

  const [step, setStep] = React.useState(1);

  const [text, setText] = React.useState("");
  const [position, setPosition] = React.useState("bottom_right");
  const [target, setTarget] = React.useState("blank");
  const [valueSize, setValueSize] = React.useState(100);
  const [defaultImage, setDefaultImage] = React.useState(true);
  const [image, setImage] = React.useState("");
  const [file, setFile] = React.useState("");
  const [file2, setFile2] = React.useState("");
  const [script, setScript] = React.useState("");
  const [copySuccess, setCopySuccess] = React.useState(false);
  const [errorSize, setErrorSize] = React.useState(false);

  const toggleWidgetModal = () => {
    setWidgetModal(!widgetModal);
    setImage("");
    setFile("");
    setStep(1);

    const header = document
      .querySelector("builderall-appshell")
      ?.shadowRoot?.querySelector(".wrapper-header");

    if (header) {
      if (!widgetModal) {
        header.classList.remove("show-shadow");
      } else {
        header.classList.add("show-shadow");
      }
    }
  };

  const nextStep = async (current) => {
    if (current === 2) {
      const imageUrl = await postWidgetSetting();
      generateWidgetScript(imageUrl);
    }
    setStep(current + 1);
  };
  const backStep = () => {
    setStep(step - 1);
  };

  const removeImage = () => {
    setFile("");
    setImage("");
    setFile2("");
    setDefaultImage(true);
  };

  const handleChangeImg = (event) => {
    setErrorSize(false);
    if (event.target.files.length === 0) {
      return;
    }
    var converted = event.target.files[0].size / (1024 * 1024);
    var roundTo = null;
    roundTo = converted.toFixed(roundTo);

    if (roundTo > 1) {
      event.target.value = null;
      setErrorSize(true);
    } else {
      setImage(event.target.files[0]);
      setFile(URL.createObjectURL(event.target.files[0]));
    }
  };

  const getWidgetSettings = async () => {
    try {
      const response = await getWidget(camapignId);
      if (response == "Error: Request failed with status code 404")
        throw new Error();
      if (response?.message == "Config not found") throw new Error();

      setText(response?.text);
      setPosition(response?.position);
      setTarget(response?.target);
      setValueSize(response?.size);
      if (response?.image) {
        setDefaultImage(false);
        setFile2(
          `${process.env.REACT_APP_LINK_API}/storage/${response?.image}`
        );
      }
    } catch (error) {
      console.log("Config not found");
    }
  };

  const postWidgetSetting = async () => {
    try {
      const response = await createWidget(
        text,
        defaultImage ? "" : image,
        position,
        target,
        valueSize,
        camapignId,
        defaultImage ? true : false
      );
      if (response?.image) {
        const fullImagePath = `${process.env.REACT_APP_LINK_API}/storage/${response?.image}`;
        setFile2(fullImagePath);
        return fullImagePath; // <-- Retorna diretamente o path atualizado
      } else {
        setFile2("");
        return ""; // ou null
      }
    } catch (error) {
      return null;
    }
  };

  const generateWidgetScript = (imageUrlFromAPI) => {
    const fallbackImage = `${window.location.origin}${DF}`;
    const finalImageUrl = imageUrlFromAPI || fallbackImage;

    let generatedScript = `
      <script>
      (function(d, h, el) {
        window.wppgFloatingButtonConfig = {
        link: '${link}',
        text: '${text}',
        position: '${position}',
        target: '_${target}',
        size: ${valueSize},
        imageUrl: '${finalImageUrl}'
        };
        el = d.createElement('script');
        el.src = h + 'button.js';
        d.head.appendChild(el);
      })(document, '${window.location.origin}/');
      </script>
    `;

    generatedScript = generatedScript.replace(/\s+/g, " ").trim();

    setScript(generatedScript);
  };

  const handleCopy = async () => {
    await navigator.clipboard.writeText(script);
    setCopySuccess(true);
  };

  React.useEffect(() => {
    if (copySuccess) {
      const timeout = setTimeout(() => {
        setCopySuccess(false);
        setErrorSize(false);
      }, 3000);

      return () => clearTimeout(timeout);
    }
    if (errorSize) {
      const timeout = setTimeout(() => {
        setErrorSize(false);
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [copySuccess, errorSize]);

  const Step2 = () => {
    return (
      <>
        <section className="detail-group">
          <p>{t("words.phone_number")}</p>
          <span>{phone}</span>
        </section>

        <section className="detail-group">
          <p>{t("words.campaign_name")}</p>
          <span>{campaignName}</span>
        </section>

        <section className="detail-group">
          <p>{t("words.call_to_action")}</p>
          <span>{text}</span>
        </section>

        <section className="detail-group">
          <p>{t("words.button_position")}</p>
          <span>
            {position == "bottom_right"
              ? t("words.bottom_right")
              : t("words.bottom_left")}
          </span>
        </section>

        <section className="detail-group">
          <p>{t("words.tab_position")}</p>
          <span>
            {target == "blank" ? t("words.open_new") : t("words.open_same")}
          </span>
        </section>

        <section className="detail-group">
          <p>{t("words.size")}</p>
          <span>{valueSize}</span>
        </section>

        <section className="detail-group">
          <p>{t("words.image")}</p>
          <span>
            {defaultImage
              ? t("words.default_image")
              : t("words.uploaded_image")}
          </span>
        </section>
      </>
    );
  };
  const Step3 = () => {
    return (
      <>
        <section className="script-text">
          <p>
            <span className="ba-color-red1">*</span>Script:
          </p>
          <article>
            <span>{script}</span>
            <builderall-icon code="b54c" onClick={handleCopy}></builderall-icon>
          </article>
          <span>
            <span className="ba-color-red1">*</span>
            {t("words.widget_script")}
          </span>
        </section>
      </>
    );
  };

  return (
    <>
      <ButtonGreen
        className="CopyBtn ba-w-100"
        onClick={() => {
          toggleWidgetModal();
          getWidgetSettings();
        }}
      >
        <WhatsAppIcon className="whatsIcon" />
        <ButtonText>{t("words.website_widget")}</ButtonText>
      </ButtonGreen>

      <CustomModal className={`ba-modal ${widgetModal && "is-active"}`}>
        <div className="ba-modal-background" onClick={toggleWidgetModal}></div>
        <div className="ba-modal-card">
          <div className="ba-modal-card-head">
            <div className="ba-flex">
              {step > 1 && (
                <builderall-icon code="arrow-left" onClick={backStep} />
              )}
              <span className="ba-modal-card-title">
                {t("words.website_widget")}
              </span>
            </div>
            {step == 3 && <p>{t("words.script_text")}</p>}
          </div>
          <div className="ba-modal-card-body">
            {step === 1 && (
              <WebsiteWidgetForm
                text={text}
                setText={setText}
                position={position}
                setPosition={setPosition}
                target={target}
                setTarget={setTarget}
                valueSize={valueSize}
                setValueSize={setValueSize}
                defaultImage={defaultImage}
                setDefaultImage={setDefaultImage}
                file={file}
                file2={file2}
                handleChangeImg={handleChangeImg}
                removeImage={removeImage}
                t={t}
              />
            )}
            {step === 2 && <Step2 />}
            {step === 3 && <Step3 />}
          </div>
          <div className="ba-modal-card-footer ba-flex ba-jc-fe">
            <Button
              classes={{ root: BtnCancel.root, label: BtnCancel.label }}
              onClick={toggleWidgetModal}
            >
              {t("words.cancel")}
            </Button>
            {step == 3 ? (
              <ButtonBlue onClick={() => toggleWidgetModal()}>
                {t("words.save")}
              </ButtonBlue>
            ) : (
              <ButtonBlue onClick={() => nextStep(step)}>
                {t("words.next")}
              </ButtonBlue>
            )}
          </div>
        </div>
      </CustomModal>

      {copySuccess === true && (
        <AlertNotify
          message={t("words.copied_link")}
          state={true}
          time={3000}
          type="success"
        />
      )}

      {errorSize === true && (
        <AlertNotify
          message={t("words.error_image_size_1mb")}
          state={true}
          time={3000}
          type="warning"
        />
      )}
    </>
  );
};

export default WebWidgetModal;
